import {
  CREATE_CATEGORY,
  CREATE_CATEGORY_FAILURE,
  CREATE_CATEGORY_SUCCESS,
  DELETE_CATEGORY,
  DELETE_CATEGORY_FAILURE,
  DELETE_CATEGORY_SUCCESS,
  GET_CATEGORIES,
  GET_CATEGORIES_FAILURE,
  GET_CATEGORIES_SUCCESS,
  GET_SINGLE_CATEGORY,
  GET_SINGLE_CATEGORY_FAILURE,
  GET_SINGLE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_FAILURE,
  UPDATE_CATEGORY_SUCCESS,
} from "./actionTypes";

export const getCategories = (payload) => {
  return {
    type: GET_CATEGORIES,
    payload,
  };
};

export const getCategoriesSuccess = (payload) => {
  return {
    type: GET_CATEGORIES_SUCCESS,
    payload,
  };
};

export const getCategoriesFailure = (payload) => {
  return {
    type: GET_CATEGORIES_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const getSingleCategory = (payload) => {
  return {
    type: GET_SINGLE_CATEGORY,
    payload,
  };
};

export const getSingleCategorySuccess = (payload) => {
  return {
    type: GET_SINGLE_CATEGORY_SUCCESS,
    payload,
  };
};

export const getSingleCategoryFailure = (payload) => {
  return {
    type: GET_SINGLE_CATEGORY_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const createCategory = (payload) => {
  return {
    type: CREATE_CATEGORY,
    payload,
  };
};

export const createCategorySuccess = (payload) => {
  return {
    type: CREATE_CATEGORY_SUCCESS,
    payload,
  };
};

export const createCategoryFailure = (payload) => {
  return {
    type: CREATE_CATEGORY_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const updateCategory = (payload) => {
  return {
    type: UPDATE_CATEGORY,
    payload,
  };
};

export const updateCategorySuccess = (payload) => {
  return {
    type: UPDATE_CATEGORY_SUCCESS,
    payload,
  };
};

export const updateCategoryFailure = (payload) => {
  return {
    type: UPDATE_CATEGORY_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const deleteCategory = (payload) => {
  return {
    type: DELETE_CATEGORY,
    payload,
  };
};

export const deleteCategorySuccess = (payload) => {
  return {
    type: DELETE_CATEGORY_SUCCESS,
    payload,
  };
};

export const deleteCategoryFailure = (payload) => {
  return {
    type: DELETE_CATEGORY_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================
